export default __webpack_public_path__ + "static/media/saltalk.c7a940d1.png";